module.exports = __webpack_public_path__ + "img/图片11.5eaa8d8a.png";